import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Employee List", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "m-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "ID"),
  /*#__PURE__*/_createElementVNode("th", null, "First Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Last Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Email Address")
], -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "text-end me-2" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "No employees to display", -1)
const _hoisted_9 = [
  _hoisted_8
]

import { ref, computed } from "vue";
import ModalView from "@/components/ModalView.vue";
import TableView from "@/components/TableView.vue";
import { Employee } from "@/model/employee";
import * as Papa from "papaparse";


export default /*#__PURE__*/_defineComponent({
  props: {
    isVisible: { type: Boolean },
    employees: null
  },
  emits: ["hide-modal"],
  setup(__props: any, { emit }) {

const props = __props as {
  isVisible: boolean;
  employees: Employee[];
}





const employeesSample = computed(() => props.employees.slice(0, 10));

function downloadCsv() {
  const csvContent = Papa.unparse(
    props.employees.map((employee) => ({
      ID: employee.id,
      "First Name": employee.firstName,
      "Last Name": employee.lastName,
      "Email Address": employee.emailAddress,
    }))
  );

  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", "employees.csv");
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalView, {
    "is-visible": __props.isVisible,
    large: true,
    onHideModal: _cache[1] || (_cache[1] = ($event: any) => (emit('hide-modal')))
  }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    body: _withCtx(() => [
      (__props.employees.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(TableView, { responsive: true }, {
              header: _withCtx(() => [
                _hoisted_4
              ]),
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(employeesSample), (employee) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: employee.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(employee.id), 1),
                    _createElementVNode("td", null, _toDisplayString(employee.firstName), 1),
                    _createElementVNode("td", null, _toDisplayString(employee.lastName), 1),
                    _createElementVNode("td", null, _toDisplayString(employee.emailAddress), 1)
                  ]))
                }), 128))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, "Showing first " + _toDisplayString(_unref(employeesSample).length) + " of " + _toDisplayString(__props.employees.length) + " entries", 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["btn btn-primary", { disabled: __props.employees.length === 0 }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (downloadCsv()))
      }, " Download CSV ", 2)
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})